// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-item {
  margin-top: 40px;
  overflow-x: hidden;
}

.me {
  display: flex;
  flex-direction: row-reverse;
}

.me-chat {
  border: 3px solid #f3f5f7;
  border-radius: 20px;
  padding: 24px 24px 34px;
  flex-direction: column;
}

.me-chat .thinking-dots-loader {
  display: none;
}

.bot {
  display: flex;
  flex-direction: row;
}

.bot-chat {
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 24px 34px;
  background: #F3F5F7;
  border-radius: 20px;
}

.main-chat-content {
  max-width: 700px;
  word-wrap: break-word;
  font-size: 14px;
  color: #141718;
}
.main-chat-content > * {
  max-width: 100%;
  overflow: hidden;
  white-space: wrap;
}

.conversation-box {
  margin-top: 35px;
}

.react-autosuggest__suggestions-container {
  position: relative;
}

.react-autosuggest__suggestions-container--open {
  position: fixed;
  bottom: 7.5%;
  width: 6%;
  text-decoration: none;
  padding-top: 12px;
  background: rgb(52, 96, 137);
  border-radius: 10px;
  color: #fff;
}
.react-autosuggest__suggestions-container--open ul,
.react-autosuggest__suggestions-container--open ol {
  list-style: none;
  margin-left: 0;
  padding: 0;
}
.react-autosuggest__suggestions-container--open ul li,
.react-autosuggest__suggestions-container--open ol li {
  padding-left: 12px;
  cursor: pointer;
}
.react-autosuggest__suggestions-container--open ul li:focus,
.react-autosuggest__suggestions-container--open ol li:focus {
  background-color: #c5d9f5;
  outline: none;
}
.react-autosuggest__suggestions-container--open ul li[aria-selected=true],
.react-autosuggest__suggestions-container--open ol li[aria-selected=true] {
  width: 100%;
  background-color: #c5d9f5;
  color: #000;
}

.image-variate-container {
  position: relative;
  width: 720px;
  height: 720px;
}

.quadrant {
  position: absolute;
  width: 360px;
  height: 360px;
  background-color: rgba(232, 11, 11, 0);
  color: #fff;
  border: 1px solid #fff;
  /* Adiciona uma borda branca */
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}
.quadrant button:nth-child(2) {
  margin-left: 10px;
}
.quadrant.one {
  top: 0;
  left: 0;
}
.quadrant.two {
  top: 0;
  right: 0;
}
.quadrant.three {
  bottom: 0;
  left: 0;
}
.quadrant.four {
  bottom: 0;
  right: 0;
}

.conversation-error .bot-chat {
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 12px 14px;
  background: rgba(216, 76, 16, 0.1);
  border-radius: 20px;
}
.conversation-error .robot-avatar {
  background-color: #D84C10;
}
.conversation-error .error-content {
  color: #D84C10;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.02em;
}
.conversation-error .error-original-request {
  background-color: #FFF;
  padding: 12px 12px 14px;
  border-radius: 8px;
  margin-top: 15px;
  color: #535657;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
}

.conversation-delay .bot-chat {
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 12px 14px;
  background: rgba(0, 132, 255, 0.1);
  border-radius: 20px;
}
.conversation-delay .robot-avatar {
  background-color: #0084FF;
}
.conversation-delay .delay-content {
  color: #0084FF;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.02em;
}

.conversation-denied .bot-chat {
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 12px 14px;
  background: rgba(140, 101, 131, 0.1);
  border-radius: 20px;
}
.conversation-denied .robot-avatar {
  background-color: #8C6583;
}
.conversation-denied .denied-content {
  color: #8C6583;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.02em;
}
.conversation-denied .denied-link {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  letter-spacing: -0.02em;
  text-decoration-line: underline;
  color: #3A3A3A;
}`, "",{"version":3,"sources":["webpack://./src/Components/Conversation/conversation.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EAQA,eAAA;EACA,cAAA;AANF;AADE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAGJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;AADF;AAGE;;EAEE,gBAAA;EACA,cAAA;EACA,UAAA;AADJ;AAGI;;EACE,kBAAA;EACA,eAAA;AAAN;AAEM;;EACE,yBAAA;EACA,aAAA;AACR;AAEM;;EACE,WAAA;EACA,yBAAA;EACA,WAAA;AACR;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AAFF;AAIE;EACE,iBAAA;AAFJ;AAKE;EACE,MAAA;EACA,OAAA;AAHJ;AAME;EACE,MAAA;EACA,QAAA;AAJJ;AAOE;EACE,SAAA;EACA,OAAA;AALJ;AAQE;EACE,SAAA;EACA,QAAA;AANJ;;AAWE;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kCAAA;EACA,mBAAA;AARJ;AAWE;EACE,yBAAA;AATJ;AAYE;EACE,cAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAXJ;AAcE;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAbJ;;AAoBE;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kCAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,yBAAA;AAlBJ;AAqBE;EACE,cAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AApBJ;;AAyBE;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,yBAAA;AAvBJ;AA0BE;EACE,cAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAzBJ;AA4BE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,uBAAA;EACA,+BAAA;EAEA,cAAA;AA5BJ","sourcesContent":[".conversation-item {\n  margin-top: 40px;\n  overflow-x: hidden;\n}\n\n.me {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.me-chat {\n  border: 3px solid #f3f5f7;\n  border-radius: 20px;\n  padding: 24px 24px 34px;\n  flex-direction: column;\n}\n\n.me-chat .thinking-dots-loader {\n  display: none;\n}\n\n.bot {\n  display: flex;\n  flex-direction: row;\n}\n\n.bot-chat {\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 24px 24px 34px;\n  background: #F3F5F7;\n  border-radius: 20px;\n}\n\n.main-chat-content {\n  max-width: 700px;\n  word-wrap: break-word;\n\n  &>* {\n    max-width: 100%;\n    overflow: hidden;\n    white-space: wrap;\n  }\n\n  font-size: 14px;\n  color: #141718;\n}\n\n.conversation-box {\n  margin-top: 35px;\n}\n\n.react-autosuggest__suggestions-container {\n  position: relative;\n}\n\n.react-autosuggest__suggestions-container--open {\n  position: fixed;\n  bottom: 7.5%;\n  width: 6%;\n  text-decoration: none;\n  padding-top: 12px;\n  background: rgb(52 96 137);\n  border-radius: 10px;\n  color: #fff;\n\n  ul,\n  ol {\n    list-style: none;\n    margin-left: 0;\n    padding: 0;\n\n    li {\n      padding-left: 12px;\n      cursor: pointer;\n\n      &:focus {\n        background-color: #c5d9f5;\n        outline: none;\n      }\n\n      &[aria-selected=\"true\"] {\n        width: 100%;\n        background-color: #c5d9f5;\n        color: #000;\n      }\n    }\n  }\n}\n\n.image-variate-container {\n  position: relative;\n  width: 720px;\n  height: 720px;\n}\n\n.quadrant {\n  position: absolute;\n  width: 360px;\n  height: 360px;\n  background-color: rgba(232, 11, 11, 0);\n  color: #fff;\n  border: 1px solid #fff;\n  /* Adiciona uma borda branca */\n  display: flex;\n  align-items: flex-end;\n  overflow: hidden;\n\n  button:nth-child(2) {\n    margin-left: 10px;\n  }\n\n  &.one {\n    top: 0;\n    left: 0;\n  }\n\n  &.two {\n    top: 0;\n    right: 0;\n  }\n\n  &.three {\n    bottom: 0;\n    left: 0;\n  }\n\n  &.four {\n    bottom: 0;\n    right: 0;\n  }\n}\n\n.conversation-error {\n  & .bot-chat {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 12px 14px;\n    background: rgba(216, 76, 16, 0.1);\n    border-radius: 20px;\n  }\n\n  & .robot-avatar {\n    background-color: #D84C10;\n  }\n\n  & .error-content {\n    color: #D84C10;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 19px;\n    letter-spacing: -0.02em;\n  }\n\n  & .error-original-request {\n    background-color: #FFF;\n    padding: 12px 12px 14px;\n    border-radius: 8px;\n    margin-top: 15px;\n    color: #535657;\n\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 19px;\n\n  }\n}\n\n\n.conversation-delay {\n  & .bot-chat {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 12px 14px;\n    background: rgba(0, 132, 255, 0.1);\n    border-radius: 20px;\n  }\n\n  & .robot-avatar {\n    background-color: #0084FF;\n  }\n\n  & .delay-content {\n    color: #0084FF;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 19px;\n    letter-spacing: -0.02em;\n  }\n}\n\n.conversation-denied {\n  & .bot-chat {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 12px 14px;\n    background: rgba(140, 101, 131, 0.1);\n    border-radius: 20px;\n  }\n\n  & .robot-avatar {\n    background-color: #8C6583;\n  }\n\n  & .denied-content {\n    color: #8C6583;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 19px;\n    letter-spacing: -0.02em;\n  }\n\n  & .denied-link {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    /* identical to box height */\n\n    letter-spacing: -0.02em;\n    text-decoration-line: underline;\n\n    color: #3A3A3A;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
